import { attributesSlice } from './slices/attributes-slice';

export const configurationAttributesReducer = attributesSlice.reducer;
